/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseAutoSaveRequestParams,
    PressReleaseAutoSaveRequestParamsFromJSON,
    PressReleaseAutoSaveRequestParamsFromJSONTyped,
    PressReleaseAutoSaveRequestParamsToJSON,
} from './PressReleaseAutoSaveRequestParams';

/**
 * プレスリリースエディタ自動保存APIのリクエストボディ
 * @export
 * @interface AutoSavePressReleaseRequestBody
 */
export interface AutoSavePressReleaseRequestBody {
    /**
     * 
     * @type {PressReleaseAutoSaveRequestParams}
     * @memberof AutoSavePressReleaseRequestBody
     */
    pressRelease: PressReleaseAutoSaveRequestParams;
    /**
     * csrf_token
     * @type {string}
     * @memberof AutoSavePressReleaseRequestBody
     */
    csrfToken: string;
    /**
     * コンフリクト検知用のtimestamp
     * @type {number}
     * @memberof AutoSavePressReleaseRequestBody
     */
    editStartedAt: number;
    /**
     * 企業id
     * @type {number}
     * @memberof AutoSavePressReleaseRequestBody
     */
    companyId: number;
    /**
     * コンフリクトしたている場合に強制上書き保存を実行する
     * @type {boolean}
     * @memberof AutoSavePressReleaseRequestBody
     */
    isForceMode?: boolean;
}

export function AutoSavePressReleaseRequestBodyFromJSON(json: any): AutoSavePressReleaseRequestBody {
    return AutoSavePressReleaseRequestBodyFromJSONTyped(json, false);
}

export function AutoSavePressReleaseRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutoSavePressReleaseRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pressRelease': PressReleaseAutoSaveRequestParamsFromJSON(json['press_release']),
        'csrfToken': json['csrf_token'],
        'editStartedAt': json['edit_started_at'],
        'companyId': json['company_id'],
        'isForceMode': !exists(json, 'is_force_mode') ? undefined : json['is_force_mode'],
    };
}

export function AutoSavePressReleaseRequestBodyToJSON(value?: AutoSavePressReleaseRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'press_release': PressReleaseAutoSaveRequestParamsToJSON(value.pressRelease),
        'csrf_token': value.csrfToken,
        'edit_started_at': value.editStartedAt,
        'company_id': value.companyId,
        'is_force_mode': value.isForceMode,
    };
}

